"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
var ramda_1 = require("ramda");
var hoistStatics = ramda_1.curry(function (To, From) {
    return hoist_non_react_statics_1["default"](To, From, {
        handledProps: true,
        mutated: true,
        mutation: true
    });
});
exports["default"] = hoistStatics;
//# sourceMappingURL=hoist.js.map